
















































import { Vue, Component, Prop } from 'vue-property-decorator'
import VueI18n from 'vue-i18n'
import { Package } from '@/models'

import AppStoreDownloadSpinner from '@/components/shop/AppStoreDownloadSpinner.vue'

@Component({
  components: {
    AppStoreDownloadSpinner
  }
})
export default class AppStoreAppDetailsOverlay extends Vue {
  @Prop() readonly i18n!: VueI18n
  @Prop() readonly pkg!: Package
  @Prop() readonly isAppInstalled!: boolean

  isInstalling = false

  onCloseClick () {
    this.$emit('close')
  }

  onInstallClick () {
    this.$emit('install')
    this.isInstalling = true
    setTimeout(() => {
      this.isInstalling = false
    }, 1200)
  }

  openApp (url: string) {
    window.open(url, '_blank')
  }

  onUnistallClick () {
    this.$emit('uninstall')
    this.isInstalling = true
    setTimeout(() => {
      this.isInstalling = false
    }, 1200)
  }
}
